import { useState, useEffect } from "react";

export function useAuthSession(supabase) {
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    // Listener registered first — no SIGNED_IN event can fire before it's ready
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setAuthLoading(false);
    });
    // getSession() called after listener is live — handles OAuth hash token exchange
    supabase.auth.getSession().then(({ data: { session } }) => {
      console.log("[Auth] getSession resolved:", session ? `logged in as ${session.user.email}` : "no session");
      setSession(session);
      setAuthLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  return { session, authLoading };
}
